import { createSelector } from '@reduxjs/toolkit'
import { DateTime } from 'luxon'
import { Service } from '@/models/service'
import {
  dayDifferenceSelector,
  insertPeriodSlice,
} from '@/store/insertPeriodSlice'

export const serviceUnavailableDaysSelector = createSelector(
  [
    dayDifferenceSelector,
    insertPeriodSlice.selectors.period,
    (_: unknown, service: Service | null) => service,
  ],
  (dayDifference, period, service): number[] => {
    if (period === null || dayDifference === 1 || service === null) {
      return []
    }

    const availableDays = Object.keys(service.dailyTimeSchedules).reduce<
      number[]
    >((acc, key) => {
      const keyNumber = parseInt(key)
      if (Number.isNaN(keyNumber)) {
        return acc
      }
      acc.push(keyNumber * 1000)
      return acc
    }, [])

    const unavailableDays: number[] = []

    let current = DateTime.fromISO(period.start, { zone: 'utc' })
    for (let i = 0; i < dayDifference; i++) {
      const millis = current.toMillis()
      if (!availableDays.includes(millis)) {
        const isoDate = current.toISODate()
        if (isoDate) {
          unavailableDays.push(DateTime.fromISO(isoDate).toMillis())
        }
      }
      current = current.plus({ days: 1 }).startOf('day')
    }

    return unavailableDays
  }
)
